import React, { useState } from 'react';

import { useDispatch } from 'react-redux';

import infoKnockoutTokens from '@amzn/meridian-tokens/base/icon/info-knockout';
import Box from '@amzn/meridian/box';
import Column from '@amzn/meridian/column';
import Icon from '@amzn/meridian/icon';
import Input from '@amzn/meridian/input';
import Row from '@amzn/meridian/row';
import SearchField from '@amzn/meridian/search-field';
import Text from '@amzn/meridian/text';
import Tooltip from '@amzn/meridian/tooltip';
import { useAppSelector } from 'src/store/store';
import { setSiteCapacityFormData } from 'src/store/updateSiteCapacitySlice/updateSiteCapacitySlice';
import { createSearchRegExp } from 'src/utils/searchUtils';

const ShiftList = () => {
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState('');
  const { siteCapacityFormData, siteCapacityFormErrors } = useAppSelector((state) => state.updateSiteCapacityPage);
  const searchRegExp = createSearchRegExp(searchValue);
  const matchedShifts = siteCapacityFormData?.shifts?.filter((shift) => searchRegExp.test(shift?.shiftCode));

  return (
    <Box
      type={matchedShifts && matchedShifts?.length > 0 ? 'outline' : 'fill'}
      spacingInset={'400'}
      overflowY={'scroll'}
      height={'240px'}
    >
      {matchedShifts?.length === 0 ? (
        <Column alignmentVertical="center" spacing="300" spacingInset="500" height="190px">
          <Text alignment="center" color="secondary">
            No results
          </Text>
        </Column>
      ) : (
        <>
          <Row widths={['fill']} spacingInset={'200'}>
            <SearchField
              value={searchValue}
              onChange={setSearchValue}
              onSubmit={() => {}}
              placeholder="Search for shift"
            />
          </Row>

          {matchedShifts?.map((shift, index) => (
            <Row widths={['fill']} key={index}>
              <Column spacingInset={'300'} spacing="100">
                <Row spacing="200">
                  <Text>{shift?.shiftCode}</Text>
                  {!!shift && shift.isActive === false && (
                    <Tooltip position="end" title="Shift will not be included in job matching results">
                      <Row spacing="200">
                        <Text color="error">(Inactive)</Text>
                        <Icon color="error" tokens={infoKnockoutTokens} />
                      </Row>
                    </Tooltip>
                  )}
                </Row>
                <Input
                  error={siteCapacityFormErrors?.shifts[shift?.shiftCode]?.error}
                  errorMessage={siteCapacityFormErrors?.shifts[shift?.shiftCode]?.errorMessage}
                  placeholder="Select slot"
                  value={shift?.slots?.toString()}
                  onChange={(slots) => {
                    dispatch(
                      setSiteCapacityFormData({
                        ...siteCapacityFormData,
                        shifts: siteCapacityFormData?.shifts?.map((s) =>
                          s?.shiftCode === shift?.shiftCode ? { ...s, slots } : s,
                        ),
                      }),
                    );
                  }}
                  suffix="Slots"
                ></Input>
              </Column>
            </Row>
          ))}
        </>
      )}
    </Box>
  );
};

export default ShiftList;
